import { FC, useMemo } from 'react';
import { Flex } from 'antd';

export interface CollapsibleHeaderCountProps {
  count?: number;
  filteredCount?: number;
}

export const CollapsibleHeaderCount: FC<CollapsibleHeaderCountProps> = (
  props
) => {
  const { count, filteredCount } = props;

  const showFiltered = useMemo(
    () => !!filteredCount && filteredCount !== count,
    [filteredCount, count]
  );

  if (!count) {
    return;
  }

  return (
    <Flex>
      ({showFiltered && `${filteredCount}/`}
      {count})
    </Flex>
  );
};
